import { Directive, Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[appCreditCard]'
})
export class CreditCardDirective {

}

@Injectable({ providedIn: 'root' })
export class AddCreditCardValidators {

  static CheckCreditCardTypeToNum(): ValidatorFn {
    return (formGroup: AbstractControl) => {

      const cardType = formGroup.get('cardType')?.value;
      const cardTypeLib = formGroup.get('cardTypeLib')?.value;
      if ((cardType && cardTypeLib) && (cardType.toLowerCase() != cardTypeLib.toLowerCase())) {
        return { cardNumTypeMismatch: true };
      }

      return null;
    };
  }

  static CheckExpirationDate(): ValidatorFn {
    return (formGroup: AbstractControl) => {

      const month = formGroup.get('expirationMonth')?.value;
      const year = formGroup.get('expirationYear')?.value;
      if (month && year) {
        const cardDate = new Date(year, month, 0, 23, 59, 59, 999);
        const currentDate = new Date();
        if (cardDate < currentDate) {
          return { cardExpiration: true };
        }
      }
      return null;
    };
  }

  static WhiteSpaceValidation(): ValidatorFn {
    return (formGroup: AbstractControl) => {

      if (formGroup.value) {
        if (formGroup.value.trim().length === 0) {
          return { required: true };
        }
      }
      return null;
    };
  }

  static MaxLimitNotZeroValidation(): ValidatorFn {
    return (formGroup: AbstractControl) => {

      if (formGroup.value) {
        // console.trace('non zero check.  value is ' + formGroup.value + ' ' + typeof (formGroup.value));
        const v = formGroup.value.replaceAll('$', '').replaceAll(',', '');
        if (v < 0.01) {
          return { zero: true };
        }
      }
      return null;
    };
  }

  static CustomRequired(): ValidatorFn {

    return (formGroup: AbstractControl) => {
      const country = formGroup.get('country')?.value;
      const state = formGroup.get('state');
      const zip = formGroup.get('zip');

      if (state !== null) {
        if ((country === 'us' || country === 'ca') && !state.value) {
          state.setErrors({ required: true });
        }
      }
      if (zip !== null) {
        if ((country === 'us' || country === 'ca') && !zip.value) {
          zip.setErrors({ required: true });
        }
        if (country != 'us' && country != 'ca') {
          if (state !== null) {
            state.setErrors({});
            state.updateValueAndValidity({ onlySelf: true });
          }
          zip.setErrors({});
          zip.updateValueAndValidity({ onlySelf: true });
        }
      }
      return null;
    };

  }

  static CustomCVV(): ValidatorFn {
    return (formGroup: AbstractControl) => {
      const cardType = formGroup.get('cardType')?.value;
      const cvv = formGroup.get('cvv');

      if (cardType === 'Amex' && cvv?.value.length < 4 && cvv?.value.length > 0) {
        cvv?.setErrors({ cvvLengthAmex: true });
        return null;
      }
      if ((cardType === 'Visa' || cardType === 'Mastercard' || cardType === 'Discover') && (cvv?.value.length < 3 || cvv?.value.length > 3) && cvv?.value.length > 0) {
        cvv?.setErrors({ cvvLength: true });
        return null;
      }
      cvv?.setErrors({});
      cvv?.updateValueAndValidity({ onlySelf: true });

      return null;
    };
  }

  static CustomZipInvalid(): ValidatorFn {

    return (formGroup: AbstractControl) => {
      const country = formGroup.get('country')?.value;
      const zip = formGroup.get('zip');
      if (zip !== null) {
        if ((country === 'us') && zip.value && ((zip.value.length > 5 && zip.value.length < 10) || zip.value.length < 5)) {
          zip.setErrors({ invalid: true });
        }
        if ((country === 'us') && (zip.value === 5 || zip.value === 9)) {
          zip.setErrors({});
          zip.updateValueAndValidity({ onlySelf: true });
        }
      }
      return null;
    };

  }


}
